<div class="mat-elevation-z13" style="margin: 5px;">
  <ng-container #container></ng-container>
</div>
